module.exports = __webpack_public_path__ + "img/sign-22.21e09b5d.jpg";